import React from "react";
import { useNavigate } from "react-router-dom";
import { DeleteIcon, MapIcon } from "../../../assets/icons";
import { useAppContext } from "../../Context/AppContext";
import CustomTooltip from "../../CustomTooltip";
import "../Provenienze.scss";

const headers = [
  { key: "tipo", label: "Layer", width: "20%" },
  { key: "chiave", label: "Identificativo", width: "20%" },
  { key: "valore", label: "Valore", width: "20%" },
  { key: "action", label: "", width: "5%" },
];

const ProvenienzeTable = ({ provenienze, handleDeleteProvenienza, edit }) => {
  const navigate = useNavigate();
  const { setMapViewTarget } = useAppContext();

  const handleMapView = (e) => {
    const target = {
      comune: e.comune,
      layer: e.tipo,
      key: e.chiave,
      value: e.valore,
    };
    setMapViewTarget(target);
    navigate("/MapView");
  };

  const renderActionCell = (provenienza) => {
    if (edit) {
      return (
        <CustomTooltip text="Elimina provenienza">
          <button
            className="provenienze-icons"
            onClick={() => handleDeleteProvenienza(provenienza)}
          >
            <DeleteIcon fillColor="var(--archeo-color)" />
          </button>
        </CustomTooltip>
      );
    }
    return (
      <CustomTooltip text="Visualizza su mappa">
        <button
          className="provenienze-icons"
          onClick={() => handleMapView(provenienza)}
        >
          <MapIcon fillColor="var(--archeo-color)" />
        </button>
      </CustomTooltip>
    );
  };

  return (
    <>
      <div className="provenienze-table-container">
        <div className="">
          <header className="provenienze-table-header">
            {headers?.map((header, index) => (
              <div
                key={index}
                className="provenienze-header-item"
                style={{
                  maxWidth: `${header.width}`,
                  minWidth: `${header.width}`,
                }}
              >
                <div className="provenienze-header-item-text">
                  {header.label}
                </div>
              </div>
            ))}
          </header>
          {provenienze && provenienze.length > 0 ? (
            provenienze.map((item, index) => {
              return (
                <div className={`provenienze-row`} key={index}>
                  {headers?.map((header, headerIndex) => (
                    <div
                      key={index + headerIndex}
                      className={`provenienze-row-item ${
                        header.className || ""
                      }`}
                      style={{ width: `${header.width}` }}
                    >
                      {header.key === "action"
                        ? renderActionCell(item)
                        : item[header.key]}
                    </div>
                  ))}
                </div>
              );
            })
          ) : (
            <div className="provenienze-row">
              <div className="provenienze-row-item" style={{ width: "100%" }}>
                Nessun dato presente
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProvenienzeTable;
